// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as React from "react";
import * as Popover from "../../resources/overlays/Popover.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CartProductDiscountFieldset from "./CartProductDiscountFieldset.res.js";

function CartProductDiscountPopover(props) {
  let dispatch = props.onRequestDispatch;
  let popover = props.popover;
  let product = props.product;
  let match;
  if (product.TAG === "Unit") {
    let match$1 = product._0;
    match = [
      match$1.id,
      match$1.discounts[0]
    ];
  } else {
    let match$2 = product._0;
    match = [
      match$2.id,
      match$2.discounts[0]
    ];
  }
  let discount = match[1];
  let productId = match[0];
  React.useEffect(() => {
    if (!popover.isOpen && discount !== undefined) {
      let exit = 0;
      switch (discount.kind) {
        case "Currency" :
        case "Percent" :
          exit = 1;
          break;
        case "Free" :
          if (discount.quantity.toNumber() === 0) {
            dispatch({
              TAG: "ProductDiscountRemoved",
              _0: productId,
              _1: discount.id
            });
          }
          break;
      }
      if (exit === 1) {
        if (discount.value !== 0) {
          
        } else {
          dispatch({
            TAG: "ProductDiscountRemoved",
            _0: productId,
            _1: discount.id
          });
        }
      }
    }
  }, [popover.isOpen]);
  let onPressRemoveDiscount = React.useCallback(() => popover.toggle(), []);
  if (popover.isOpen) {
    return JsxRuntime.jsx(Popover.make, {
      children: JsxRuntime.jsx(Popover.Dialog.make, {
        children: JsxRuntime.jsx(Box.make, {
          children: JsxRuntime.jsx(CartProductDiscountFieldset.make, {
            product: product,
            discount: discount,
            onPressRemoveDiscount: onPressRemoveDiscount,
            onRequestDispatch: dispatch
          }),
          spaceX: "large",
          spaceTop: "xlarge",
          spaceBottom: "medium"
        }),
        ariaProps: props.popoverAriaProps.overlayProps
      }),
      triggerRef: props.popoverTriggerRef,
      state: popover,
      placement: "bottom end",
      modal: false
    });
  } else {
    return null;
  }
}

let make = React.memo(CartProductDiscountPopover);

export {
  make,
}
/* make Not a pure module */
